// extracted by mini-css-extract-plugin
module.exports = {"copyright":"-nMtQ0"};